import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-survey-infos-edit',
  templateUrl: './survey-infos-edit.component.html',
  styleUrls: ['./survey-infos-edit.component.scss']
})
export class SurveyInfosEditComponent implements OnInit {

  @Input() survey:any = {};

  constructor() { }

  ngOnInit(): void {
  }

}
